export default __webpack_public_path__ + "static/media/foto6.ea62864d.jpg";